import { useEffect, useRef, useState } from 'react';

// GazeControl の視点合わせアニメーションまわりの状態を1箇所に集約するフック。
// 状態遷移の統括は MatchGazeButton（押下時にここの setter 群を呼ぶ）。
export function useGazeMatchState(errorGlbPath, motifGlbPath) {
  // 視点合わせを一度実行したか（ボタンのトグル・「完了」の点滅誘導に使う）
  const [isGazeMatched, setIsGazeMatched] = useState(false);
  // アニメーション完了後に「誤り」のモデルをモチーフへ差し替えるフラグ
  // （「顕在化された視点」は誤りモデルのまま、目を一致視点へ置く合図にだけ使う）
  const [showMotifModel, setShowMotifModel] = useState(false);
  // 「誤り」ビューのカメラ位置（モデル差替時の再構築で正しい位置に着地させる）
  const [errorCameraPos, setErrorCameraPos] = useState(null);
  // 視点移動アニメーション中だけ true（方向説明の吹き出しを3Dキャンバス上に表示する）
  const [isGazeAnimating, setIsGazeAnimating] = useState(false);

  // 命令的アニメーション用に各ビューの参照を保持
  const errorViewerRef = useRef(null);
  const wrongViewerRef = useRef(null);

  // 問題（モデル）が切り替わったら演習状態をリセットする
  useEffect(() => {
    setShowMotifModel(false);
    setErrorCameraPos(null);
    setIsGazeMatched(false);
    setIsGazeAnimating(false);
  }, [errorGlbPath]);

  // 「誤り」に表示するモデル（差替後はモチーフモデル）
  const errorViewGlbPath = showMotifModel ? motifGlbPath : errorGlbPath;

  return {
    isGazeMatched,
    setIsGazeMatched,
    showMotifModel,
    setShowMotifModel,
    errorCameraPos,
    setErrorCameraPos,
    isGazeAnimating,
    setIsGazeAnimating,
    errorViewerRef,
    wrongViewerRef,
    errorViewGlbPath,
  };
}
